import { defineMessages, IntlShape } from "react-intl";

import DealStageType from "@mapmycustomers/shared/enum/DealStageType";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [DealStageType.DEFAULT]: {
    id: "dealStageType.default",
    defaultMessage: "Open Stage",
    description: "Default Deal Stage type display message",
  },
  [DealStageType.LOST]: {
    id: "dealStageType.lost",
    defaultMessage: "Closed Lost",
    description: "Default Deal Stage type display message",
  },
  [DealStageType.WON]: {
    id: "dealStageType.won",
    defaultMessage: "Closed Won",
    description: "Won Deal Stage type display message",
  },
});

// The one-word form, for a tag that sits beside the stage's own name — which usually already reads
// "Closed Lost", so repeating the full type there says the same thing twice and wraps to two lines.
//
// Keyed on the two closing types alone rather than all of DealStageType: an open stage is never
// tagged, so it needs no wording, and this stays total over the types that are.
const shortMessages = defineMessages<DealStageType.LOST | DealStageType.WON>({
  [DealStageType.LOST]: {
    id: "dealStageType.short.lost",
    defaultMessage: "Lost",
    description:
      "One-word form of the Closed Lost deal stage type, for a tag shown next to a stage's name",
  },
  [DealStageType.WON]: {
    id: "dealStageType.short.won",
    defaultMessage: "Won",
    description:
      "One-word form of the Closed Won deal stage type, for a tag shown next to a stage's name",
  },
});

const getDealStageTypeDisplayMessage = (intl: IntlShape, type: DealStageType) =>
  getDisplayName(intl, messages, type, "DealStageType");

export const getShortDealStageTypeDisplayMessage = (
  intl: IntlShape,
  type: DealStageType.LOST | DealStageType.WON
) => getDisplayName(intl, shortMessages, type, "DealStageType");

export default getDealStageTypeDisplayMessage;
